<template>
    <div>
        <div class="header primary-bg">
            <div class=" pt10 pl10 pr10" style="padding-bottom:70px">
                <div class="box-horizontal white-box-header p10">
                    <div class="logo">
                        <img v-bind:src="get.data.logo" alt="" style="height:40px">
                    </div>
                    <div class="flex-1 nama white text-right ">
                        <strong class="f15 block primary-color">{{get.data.namaWifi}}</strong>
                        <span class="block gray" v-show="false">{{get.data.telpWifi}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-box">
            <div class="ml10 mr10 mb10 " style="margin-top:-50px">
                <!--
                <div class="data bg-round-white p10">
                    <div class="box-horizontal">
                        <div class="flex-1 f13">
                            <small class="block gray">Nama</small>
                            <div class="loading" v-show="get.data.loadingNama" style="height:20px;"></div>
                            <span v-show="!get.data.loadingNama">{{get.data.nama}} <span class="primary-color">({{get.data.prefix+""+get.data.fake_id}})</span></span>
                        </div>
                        <div class="flex-1">
                            <small class="block gray text-right">Paket</small>
                            <div class="loading" v-show="get.data.loadingNama" style="height:20px;"></div>
                            <span class="block text-right f12 primary-color"  v-show="!get.data.loadingNama">{{get.data.paket}}</span>
                        </div>
                    </div>
                    <div class="box-horizontal">
                        <div class="flex-1 f13">
                            <small class="block gray">Area</small>
                            <div class="loading" v-show="get.data.loadingNama" style="height:20px;"></div>
                            <span class="block f12 primary-color" v-show="!get.data.loadingNama">{{get.data.area}}</span>
                        </div>
                        <div class="flex-1">
                            <small class="block gray text-right">Tarif</small>
                            <div class="loading" v-show="get.data.loadingNama" style="height:20px;"></div>
                            <span class="block text-right f12 primary-color" v-show="!get.data.loadingNama">{{get.data.tarif}}</span>
                        </div>
                    </div>
                </div> -->
                
                <div class="bg-round-white p10">
                    <div class="box-horizontal">
                        <div class="flex-1 text-center" @click="met.bantuan()">
                            <img src="@/assets/bantuan.png" alt="" style="height:30px">
                            <small class="block gray">Pengaduan</small>
                        </div>
                        <div class="flex-1 text-center" @click="met.history()">
                            <img src="@/assets/list_biru.png" alt="" style="height:30px">
                            <small class="block gray">History Bayar</small>
                        </div>
                        <div class="flex-1 text-center" @click="met.modemku()">
                            <img src="@/assets/router.png" alt="" style="height:30px">
                            <small class="block gray">Modemku</small>
                        </div>
                        <div class="flex-1 text-center" @click="met.akun()">
                            <img src="@/assets/akun.png" alt="" style="height:30px">
                            <small class="block gray">Akun</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ml10 mr10 mb10">
                <carousel :perPage="1" :autoplay="true" :paginationEnabled="true" :paginationPadding="1" :paginationSize="5" :paginationActiveColor="'#737373'">
                    <slide v-for="(u, index) in get.data.slider" v-bind:key="index">
                        <img :src="get.data.assetsLain+'slider/'+u" alt="" style="width:100%">
                    </slide>
                </carousel>
            </div>
            <div class="ml10 mr10 mb10">
                <div class="bg-round-white p10">
                    <span class="gray">Selamat Datang Bapak/Ibu :</span>
                    <span class="hitam block f15"><strong>{{get.data.nama}}</strong></span> 
                    <span class="hitam block ">{{get.data.telp}}</span> 
                </div>
            </div>
            <div class="ml10 mr10 mb10" v-show="get.data.isReActive">
                <div class="bg-round-white p10">
                    <span class="block green"><strong>INFO INTERNET :</strong></span> 
                    <span class="hitam">{{get.data.isReActivePesan}}</span>
                </div>
            </div>
            <div class="ml10 mr10 mb10">
                <div class="bg-round-white p10">
                    <span class="block primary-color">Info :</span> 
                    <span class="hitam">Setelah anda melakukan pembayaran online, pastikan anda membuka aplikasi untuk memastikan pembayaran anda berhasil.</span>
                </div>
            </div>
            <!--
            <div class="ml10 mr10 mb10">
                <div class="p10">
                    <div class="box-horizontal">
                        <div class="flex-1 text-center" @click="met.bantuan()">
                            <img src="@/assets/bantuan.png" alt="" style="height:30px">
                            <small class="block gray">Pengaduan</small>
                        </div>
                        <div class="flex-1 text-center" @click="met.history()">
                            <img src="@/assets/list_biru.png" alt="" style="height:30px">
                            <small class="block gray">History Bayar</small>
                        </div>
                        <div class="flex-1 text-center" @click="met.akun()">
                            <img src="@/assets/akun.png" alt="" style="height:30px">
                            <small class="block gray">Akun</small>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="ml10 mr10 mb10">
                <div class="data bg-round-white p10">
                    <div class="box-horizontal">
                        <div class="flex-1">
                            <small class="block hitam">Tagihan anda di Bulan </small>
                            <div class="loading" v-show="get.data.loadingTagihan" style="height:20px;"></div>
                            <span v-show="!get.data.loadingTagihan">
                                <small class="block primary-color" >{{get.data.bulan}}</small>

                                <small class="block primary-color" v-if="get.data.bulan1 != null && get.data.bulan1Isolir != 'ya'">
                                    {{get.data.bulan1}} 
                                    <span v-if="get.data.bulan1Isolir == 'awal'">(
                                        <span class="red">
                                            Bulan awal anda terisolir
                                        </span>
                                    )</span>
                                </small>
                                <small class="block primary-color" v-if="get.data.bulan2 != null && get.data.bulan2Isolir != 'ya'">
                                    {{get.data.bulan2}} 
                                    <span v-if="get.data.bulan2Isolir == 'awal'">
                                        (
                                        <span class="red">
                                            Bulan awal anda terisolir
                                        </span>
                                        )
                                    </span>
                                </small>
                                <small class="block primary-color mb15 block" v-if="get.data.bulan3 != null && get.data.bulan2Isolir != 'ya'">
                                    {{get.data.bulan3}} 
                                    <span v-if="get.data.bulan3Isolir == 'awal'">
                                        (
                                        <span class="red">
                                            Bulan awal anda terisolir
                                        </span>
                                        )
                                    </span>
                                </small>
                            </span>
                            <div class="mt10 loading" v-show="get.data.loadingTagihan" style="height:30px;"></div>
                            <span class="f15 primary-color mt10 block" v-show="!get.data.loadingTagihan">{{get.data.tarifBulanIni}}</span>
                        </div>
                        
                        <div class="text-right" v-show="get.data.loadingTagihan">
                            <div class="loading" style="margin-left:20px;height:50px;"></div>
                        </div>
                        <div class="text-right" v-if="get.data.terimaPayment == null">
                            <div v-show="!get.data.loadingTagihan">
                                <div v-if="get.data.stat == null">
                                    <button class="btn btn-sm btn-red" v-if="get.data.bulan0 != null" @click="met.bayar()">Bayar Semua</button>
                                    <button class="btn btn-sm btn-success" v-else @click="met.history()">Lunas</button>
                                </div>
                                <div v-else>
                                    <button class="btn btn-sm btn-red" v-if="get.data.stat == null" @click="met.bayar()">Bayar Semua</button>
                                    <button class="btn btn-sm btn-success" v-else-if="get.data.stat == 'done'" @click="met.history()">Lunas</button>
                                    <button class="btn btn-sm btn-yellow" v-else-if="get.data.stat == 'pending'" @click="met.history()">Pending</button>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1 text-right" v-else>
                            <span class="gray mb10 block">Bayar via Kang Tagih ya :)</span>
                            <div v-if="get.data.stat == null">
                                <h3 class="red m0" v-if="get.data.bulan0 != null">Belum Lunas</h3>
                                <h3 class="green m0" v-else> Lunas</h3>
                            </div>
                        </div>
                    </div>
                    <div class="box-horizontal">
                        <div class="flex-1">
                            <small class="gray">Bayar Tagihan anda sebelum</small>
                        </div>
                        <div class="flex-1 text-right">
                            <div class="loading" v-show="get.data.loadingTagihan" style="height:20px;"></div>
                            <small class="hitam" v-show="!get.data.loadingTagihan">{{get.data.tanggallimit}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ml10 mr10">
                <div class="data bg-round-white p10">
                    <span class="hitam">Pengumuman</span>
                    <div class="mt10 loading" v-show="get.data.loadingPengumuman" style="height:60px;"></div>
                    <div class="box-pengumuman" v-show="!get.data.loadingPengumuman">
                        <div class="pengumuman-item bt-1 pb10 pt10 box-horizontal mb0" v-for="(u, index) in pengumuman.data.list" @click="pengumuman.detail(u)">
                            <div class="flex-1">
                                <p class="block m0 mb5 primary-color">{{u.judul}}</p>
                                <small class="gray block">{{pengumuman.readmore(u.text)}}</small>
                                <small class="gray">{{myGlobal.tglIndo(u.tanggal)}}</small>
                            </div>
                            <div class="status">
                                <small v-if="u.status == 'urgent' " class="urgent btn btn-sm btn-red pl10 pr10">PENTING!</small>
                                <small v-else class="btn btn-sm btn-info pl10 pr10">INFO</small>
                            </div>
                        </div>

                        <div v-if="pengumuman.data.list.length == 0">
                            <strong class="text-center gray block mt20 mb20">Tidak ada Pengumuman</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" v-show="get.data.isIsolir" style="background-color: rgba(0,0,0,0.2);">
            <div class="inner-modal bg-round-white p10 m10 text-center">
                <h1 class="gray"><i>Oops...</i></h1>
                <p class="f15">Sepertinya Internet anda telah terisolir</p>
                <p class="f15 ">Segera bayar internetnya ya, agar internet anda aktif kembali :)</p>
                
                <button class="btn primary-bg-round white mt20 pr20" @click="met.isolirHide()">OK</button>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/MyGlobal'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import { Carousel, Slide } from 'vue-carousel';
import { assetsLain } from '@/var.js'

export default {
    components: {
        Carousel,
        Slide
    },
    setup() {
        const get = {
            data: reactive({
                /* loading */

                loadingNama: true,
                loadingTagihan: true,
                loadingPengumuman: true,

                /* loading end */
                this: '',
                nama: "", //'Contoh',
                telp: "", //'Contoh',
                namaWifi: "", //'Wifi NET',
                telpWifi: "",
                paket: "", //'Contoh Paket',
                area: "", //'Areaku',
                tarif: 'Rp. 0',
                bulan: "", //'bulan contoh',
                bulan0: null, 
                bulan0Isolir: null, // NOPAKAI
                bulan1: null,
                bulan1Isolir: null,
                bulan2: null,
                bulan2Isolir: null,
                bulan3: null,
                bulan3Isolir: null,
                tarifBulanIni: 'Rp. 0',
                tanggallimit: '01 Januari 1010',
                logo: '',
                cs: '',
                cs_nama: '',
                fake_id: '',
                prefix: '',
                stat: null, // belum bayar

                terimaPayment: null,

                isReActive: false,
                isReActivePesan: null,

                isIsolir: false,

                assetsLain: assetsLain,
                slider: []
            }),
            profil() {
                
                if (sessionStorage.getItem("data_profil") != null) {
                    //console.log("local");
                    var d = JSON.parse(sessionStorage.getItem("data_profil"));
                    
                    this.data.nama = d.unama;
                    this.data.telp = d.uwa;
                    this.data.fake_id = d.fake_id;
                    this.data.prefix = d.prefix;
                    this.data.paket = d.pnama;
                    this.data.area = d.uanama;
                    this.data.namaWifi = d.anama;
                    this.data.telpWifi = d.ahp;
                    this.data.cs = d.cs;
                    this.data.cs_nama = d.cs_nama;
                    this.data.tarif = myGlobal.ribu(d.ptarif); 
                    this.data.logo = myGlobal.assets()+'images/'+d.logo;

                    if (d.stat == "belum") {
                        this.data.stat = false;
                    } else if (d.stat == "sudah") {
                        this.data.stat = true;
                    }

                    this.data.loadingNama = false;
                    this.data.terimaPayment = d.z_payment;

                    //console.log(JSON.stringify(d));
                    
                    return false;
                }

                // BELUM DISIMPAN

                //console.log(sessionStorage.getItem("tokenu"));

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu")
                };
            
                var apiUrl = inter.Profil(); 

                myGlobal.call(datax,apiUrl).then(x => {

                    // console.log(JSON.stringify(x));

                    if (x.status == true) {
                        var d = x.data;

                        sessionStorage.setItem("data_profil", JSON.stringify(d));

                        this.data.nama = d.unama;
                        this.data.telp = d.uwa;
                        this.data.fake_id = d.fake_id;
                        this.data.prefix = d.prefix;
                        this.data.paket = d.pnama;
                        this.data.area = d.uanama;
                        this.data.namaWifi = d.anama;
                        this.data.telpWifi = d.ahp;
                        this.data.cs = d.cs;
                        this.data.cs_nama = d.cs_nama;
                        
                        this.data.tarif = myGlobal.ribu(d.ptarif); 
                        this.data.logo = myGlobal.assets()+'images/'+d.logo;

                        if (d.stat == "belum") {
                            //this.data.stat = false;
                        } else if (d.stat == "sudah") {
                            //this.data.stat = true;
                        }

                        this.data.loadingNama = false;
                        this.data.terimaPayment = d.z_payment;
                        
                        if (myGlobal.versiCode() >= 560) {
                            myGlobal.android('ownerid', d.topic);
                        }

                    } else {
                        
                    }
                    
                })
            },
            bulanIni() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu")
                };
            
                var apiUrl = inter.Bulanini(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));

                    if (x.status == true) {
                        var d = x.data;
                        this.data.tanggallimit = d.tagihantgl;
                        this.data.tarifBulanIni = myGlobal.ribu(d.jumlah);
                        this.data.bulan = d.bulan+ " " +d.tahun;
                    } else { 
                        
                    }
                })
            },
            tagihancek() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu")
                };
            
                var apiUrl = inter.Tagihan(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    // console.log(JSON.stringify(x));

                    if (x.status == true) {
                        var d = x.data;

                        
                        sessionStorage.setItem('browserTokenUid', d.uid);

                        console.log("browserTokenUid tg : "+sessionStorage.getItem('browserTokenUid'))

                        //myGlobal.android("toast", "isolir "+ d.isolir );

                        this.data.tanggallimit = d.last + " " +d.bulanNow + " " +d.tahunAngka;

                        this.data.bulan = d.bulanNow + " " + d.tahunAngka;

                        var ppne = d.ppn;
                        var ppn = (parseInt(ppne) / 100 ) * parseInt(d.tarif);

                        var tariff = ( myGlobal.sParseInt(d.tarif) + myGlobal.sParseInt(d.tambahan1) + myGlobal.sParseInt(d.tambahan2) + ppn ) - myGlobal.sParseInt(d.diskon);

                        var tarifx = tariff;

                        if (d.isBayar != "sudah") {
                            this.data.bulan0 = d.bulanmin3data.bulanText + " " + d.bulanmin3data.tahunAngka;
                            //this.data.bulan0Isolir = d.bulanmin3data.bulanText + " " + d.bulanmin3data.tahunAngka;
                        } else {
                            // LUNAS KESELURUHAN

                            get.bacaInternet();
                        }

                        if (d.bulanmin3data.isBayar != "sudah") {
                            if (d.bulanmin3data.isBayar != "register") {
                                this.data.bulan3 = d.bulanmin3data.bulanText + " " + d.bulanmin3data.tahunAngka;
                                tarifx = tarifx + tariff;

                                this.data.bulan3Isolir = d.bulanmin3data.isIsolir;
                            }
                        }
                        if (d.bulanmin2data.isBayar != "sudah") {
                            if (d.bulanmin2data.isBayar != "register") {
                                this.data.bulan2 = d.bulanmin2data.bulanText + " " + d.bulanmin2data.tahunAngka;
                                tarifx = tarifx + tariff;

                                this.data.bulan2Isolir = d.bulanmin2data.isIsolir;
                            } 
                        }
                        if (d.bulanmin1data.isBayar != "sudah") { 
                            if (d.bulanmin1data.isBayar != "register") {
                                this.data.bulan1 = d.bulanmin1data.bulanText + " " + d.bulanmin1data.tahunAngka;
                                tarifx = tarifx + tariff;
                                
                                this.data.bulan1Isolir = d.bulanmin1data.isIsolir;
                            } 
                        }

                        this.data.tarifBulanIni = myGlobal.ribu(tarifx);
                        
                        this.data.stat = d.stat_bayar; // null / pending / done

                        //console.log(this.data.stat);

                        /*
                        if (d.isBayar == "sudah" &&
                         d.bulanmin3data.isBayar == "sudah" && 
                         d.bulanmin2data.isBayar == "sudah" && 
                         d.bulanmin1data.isBayar == "sudah" ) {
                        }
                        */

                        this.data.loadingTagihan = false;

                        if (d.isolir == "ya") {
                            if (sessionStorage.getItem("isolirNotif") == null) {
                                get.data.isIsolir = true;
                            }
                        }

                    } else { 
                        
                    }
                })
            },
            bacaInternet() {
                
                var datax = {
                    token: 'TangTung ' +sessionStorage.getItem('tokenu')
                };
            
                var apiUrl = inter.Internet();

                myGlobal.call(datax,apiUrl).then(x => {
                    console.log("Baca Internet");
                    //console.log(JSON.stringify(x));

                    //data.loading = false;

                    if (x.status == true) {
                        //this.data.list = x.data;
                        //theGet.data.Total = x.pesan;
                        
                        get.data.isReActive = true;
                        get.data.isReActivePesan = "Internet Berhasil di-Aktifkan kembali";

                        get.data.loadingPengumuman = false;
                    } else {
                        // myGlobal.android("toast", x.pesan);
                        
                        if (x.pesan != "") {
                            get.data.isReActive = true;
                            get.data.isReActivePesan = x.pesan;
                        }

                    }

                    this.data.loading = false;
                })
            }
        }
        
        const pengumuman = {
            data: reactive({
                this: '',
                loading: true,
                list: []
            }),
            readmore(text) {
                var c = text;
                let lastText = "";
                if(text.length > 30) {
                    lastText = "...";
                }
                return c.substr(0, 30)+lastText;
            },
            detail(datax){
                router.push({ 
                    name: 'pengumuman-detail', 
                    params: {
                        data: datax
                    } 
                });
            },
            list() {
                var datax = {
                    token: 'TangTung ' +sessionStorage.getItem('tokenu'),
                    limit: 5
                };
            
                var apiUrl = inter.Pengumuman();

                myGlobal.call(datax,apiUrl).then(x => {
                    // console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        this.data.list = x.data;
                        //theGet.data.Total = x.pesan;

                        get.data.loadingPengumuman = false;
                    } else {
                        
                    }

                    this.data.loading = false;
                })
            }
        }

        const token = {
            data: reactive({
                x: null
            }),
            get(val) {
                sessionStorage.setItem("tokenu", val);
                //console.log(val);

                if (val == "no-token") {
                    location.href="#/";
                }
            }
        }

        const met = {
            copy() {
                router.push({ 
                    name: 'success-va'
                });
            },
            bayar() {
                router.push({ 
                    name: 'pembayaran'
                });
            },
            bantuan() {
                router.push({ 
                    name: 'bantuan'
                });
            },
            history() {
                router.push({ 
                    name: 'history'
                });
            },
            modemku() {
                router.push({ 
                    name: 'modem'
                });
            },
            akun() {

                //console.log(get.data.nama);
                
                var pax = {
                    nama: get.data.nama,
                    fake_id: get.data.fake_id,
                    prefix: get.data.prefix,
                    wa: get.data.telp,
                    paket: get.data.paket,
                    area: get.data.area,
                    tarif: get.data.tarif,
                    cs: get.data.cs,
                    cs_nama: get.data.cs_nama
                }

                router.push({ 
                    name: 'akun', 
                    params: {
                        data: pax
                    } 
                });
            },
            isolirHide() {
                sessionStorage.setItem("isolirNotif", "hide");
                get.data.isIsolir = false;
            }
        }


        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }
        const slider = {
            list() {
                var datax = {
                    token: 'TangTung ' +sessionStorage.getItem('tokenu'),
                    limit: 5
                };
            
                var apiUrl = inter.Slider();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log("hasil slider");
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        get.data.slider = x.data;
                    } else {
                        
                    }
                })
            }
        }

        return {
            get,
            token,
            met,
            redirectx,
            myGlobal,
            pengumuman,
            slider
        }


        /*

        TINGGAL LOGOUT DAN  HALAMAN BERANDA

        */

    },
    mounted () {        

        this.redirectx.checkApp();

        this.token.get(myGlobal.androidGet("tokenu"));
        
        this.slider.list();

        this.get.profil();

        this.get.tagihancek();

        this.pengumuman.list();

        sessionStorage.removeItem('AkunPageData');

        console.log("browserTokenUid : "+sessionStorage.getItem('browserTokenUid'));

        //this.get.bulanIni();
    }
    //
}
</script>

<style scoped>
.VueCarousel-dot-container {
    margin-top: 0 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/User/Beranda/main.vue